import type { VoidFunctionComponent } from 'react';

import { plural } from '../../../../shared/helpers';
import Icon, { icons } from '../../generic/Icon';
import { RouterLink } from '../../generic/Link';

import styles from './ProjectPreview.module.less';

type Props = {
  baseURL: string;
  dependencyCount: number;
  licenseCount: number;
  todoCount: number;
};

/**
 * List of stats (dependencies, licenses, obligations) displayed in the header
 */
const HeaderStatsList: VoidFunctionComponent<Props> = ({
  baseURL,
  dependencyCount,
  licenseCount,
  todoCount,
}) => (
  <ul className="list-inline project-preview-header-list">
    {dependencyCount > 0 && (
      <li>
        <RouterLink to={`${baseURL}/browse/dependencies`} className={styles.statsLink}>
          <strong>{dependencyCount}</strong> {plural(dependencyCount, 'dependency', 'dependencies')}
          <span className={`margin-left-xs ${styles.statsLinkIcon}`}>
            <Icon icon={icons.angleDoubleRight} />
          </span>
        </RouterLink>
      </li>
    )}
    <li>
      <RouterLink to={`${baseURL}/browse/licenses`} className={styles.statsLink}>
        <strong>{licenseCount}</strong> {plural(licenseCount, 'license')}
        <span className={`margin-left-xs ${styles.statsLinkIcon}`}>
          <Icon icon={icons.angleDoubleRight} />
        </span>
      </RouterLink>
    </li>
    <li>
      <RouterLink to={`${baseURL}/browse/licenses`} className={styles.statsLink}>
        <strong>{todoCount}</strong> {plural(todoCount, 'obligation', 'obligations')}
        <span className={`margin-left-xs ${styles.statsLinkIcon}`}>
          <Icon icon={icons.angleDoubleRight} />
        </span>
      </RouterLink>
    </li>
  </ul>
);

export default HeaderStatsList;
